<template>
  <header class="p2p-wizard">
    <div class="p2p-between">
      <div class="p2p-row" style="gap:12px;min-width:0">
        <span v-if="!image" aria-hidden="true" class="p2p-wizard-logo empty">
          <v-icon small color="#8a8a99">mdi-plus</v-icon>
        </span>
        <MediaImg v-else :src="image" ratio="1" class="p2p-wizard-logo" />
        <div style="min-width:0">
          <div class="p2p-row" style="gap:4px">
            <h1 v-if="!editing" class="p2p-wizard-title">{{ title }}</h1>
            <input v-else ref="name" v-model="draft" class="p2p-input" style="max-width:320px;min-height:36px"
                   aria-label="Project name" @keyup.enter="save" @keyup.esc="editing = false" @blur="save">
            <button v-if="project && project.id && !editing && renamable" type="button" class="p2p-icon-btn" aria-label="Rename project" @click="startRename">
              <v-icon small>mdi-pencil-outline</v-icon>
            </button>
          </div>
          <div class="p2p-faint p2p-mono">{{ subtitle }}</div>
        </div>
      </div>
      <span class="p2p-row p2p-muted" style="gap:8px"><span :class="['p2p-dot', savedTone]"></span>{{ savedText }}</span>
    </div>
    <nav class="p2p-steps" aria-label="Progress">
      <template v-for="(step, index) in steps">
        <router-link v-if="reachable(index)" :key="step.key" :to="link(step)" :aria-current="current === step.key ? 'step' : null"
                     :class="['p2p-step', { on: current === step.key, done: index < currentIndex }]">
          <span class="n"><v-icon v-if="index < currentIndex" x-small color="#d6f34b">mdi-check-bold</v-icon><template v-else>{{ index + 1 }}</template></span>
          {{ step.label }}
        </router-link>
        <span v-else :key="step.key" class="p2p-step locked" aria-disabled="true"><span class="n">{{ index + 1 }}</span>{{ step.label }}</span>
      </template>
    </nav>
  </header>
</template>

<script>
import MediaImg from './MediaImg.vue';

export const STEPS = [
  { key: 'source', label: 'Source' }, { key: 'formats', label: 'Formats' }, { key: 'review', label: 'Review' },
  { key: 'accounts', label: 'Accounts' }, { key: 'publish', label: 'Publish' }
];

export default {
  name: 'WizardHeader',
  components: { MediaImg },
  props: {
    project: { type: Object, default: null },
    current: { type: String, required: true },
    furthest: { type: Number, default: 0 },
    saving: { type: Boolean, default: false },
    renamable: { type: Boolean, default: true }
  },
  data: () => ({ editing: false, draft: '', steps: STEPS }),
  computed: {
    currentIndex() { return STEPS.findIndex(step => step.key === this.current); },
    title() { return this.project && this.project.knowledge_ready ? this.project.name : 'Create posts'; },
    image() { return this.project && this.project.product ? this.project.product.image_url : ''; },
    subtitle() {
      if (!this.project || !this.project.id) return 'New project, named after your site';
      return this.project.primary_url ? this.project.primary_url.replace(/^https?:\/\//, '').replace(/\/$/, '') : 'Your project';
    },
    savedText() { return this.saving ? 'Saving…' : this.project && this.project.id ? 'Saved to your project' : 'Nothing saved yet'; },
    savedTone() { return this.saving ? 'warn pulse' : this.project && this.project.id ? 'good' : ''; }
  },
  methods: {
    reachable(index) { return !!(this.project && this.project.id) && (index <= Math.max(this.furthest, this.currentIndex)); },
    link(step) { return '/create/' + this.project.id + '/' + step.key; },
    startRename() {
      this.draft = this.project.name;
      this.editing = true;
      this.$nextTick(() => { if (this.$refs.name) this.$refs.name.focus(); });
    },
    save() {
      if (!this.editing) return;
      this.editing = false;
      const name = this.draft.trim();
      if (name && name !== this.project.name) this.$emit('rename', name);
    }
  }
};
</script>

<style>
.p2p-wizard-title{margin:0;font:700 22px/1.15 var(--font-display);letter-spacing:-.02em;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:min(60vw,520px)}
.p2p-wizard-logo{flex:0 0 auto;width:40px!important;height:40px;border-radius:10px;border:1px solid var(--p2p-input-line);overflow:hidden}
.p2p-wizard-logo.empty{display:inline-grid;place-items:center;border:1.5px dashed var(--p2p-line-strong)}
</style>
